import { render, staticRenderFns } from "./virtusDemoReset.vue?vue&type=template&id=03cefab9&scoped=true&"
import script from "./virtusDemoReset.vue?vue&type=script&lang=js&"
export * from "./virtusDemoReset.vue?vue&type=script&lang=js&"
import style0 from "./virtusDemoReset.vue?vue&type=style&index=0&id=03cefab9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cefab9",
  null
  
)

export default component.exports